import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'
import { ErrorFallback } from './components/ErrorFallback'

// Initialize Sentry for error tracking (production only)
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://a6d9283a08638b81d77b419608c63396@o4510726141444096.ingest.de.sentry.io/4510726160056400",
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    sendDefaultPii: true,
  })
}

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
const isDevMode = import.meta.env.VITE_DEV_MODE === 'true'

// Only wrap with ClerkProvider when we have a key and not in dev mode
const shouldUseClerk = !isDevMode && !!PUBLISHABLE_KEY

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      {shouldUseClerk ? (
        <ClerkProvider
          publishableKey={PUBLISHABLE_KEY}
          signInUrl="/login"
          signUpUrl="/signup"
          afterSignOutUrl="/">
          <App />
        </ClerkProvider>
      ) : (
        <App />
      )}
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
